module.exports = __webpack_public_path__ + "media/images/emblems/Origlio-coat_of_arms-05e8e25753b34b7499a6f038a75653bf.svg";